<!--  -->
<template>
  <div class="msg-box" >
    <div v-show="!isActive" class="main-box" @mouseenter="enter" @mouseover="enter" @mouseout="leave">
      <img src="../../assets/images/message_nor.png"> 
    </div>
    <div v-show="isActive" class="main-box-active" @mouseenter="enter" @mouseover="enter" @mouseout="leave" @click="leaveMsg">
       <span>欢迎留言</span>
      <img src="../../assets/images/message_pre.png"> 
    </div>
    <div class="leave-msg-box" v-show="isShow">
      <div class="msg-wrapper" v-show="!isCommit">
        <img class="del-img" src="../../assets/images/btn_del.png" @click="cancel">
        <div class="title-wrapper">
          <h3>欢迎留言</h3>
          <p>请填写以下信息，我们会尽快给您答复！</p>
        </div>
        <div class="content-wrapper">
          <p>姓名</p>
          <input type="text" name="name" id="name"  >
          <p>联系方式 (邮箱/手机号码)</p>
          <input type="text" name="connectLink" id="connectLink" >
          <p>留言信息</p>
          <textarea class="textarea" name="msg" id="msg" > </textarea>
          <div class="commit-btn">
            <button @click="commitMsg">提交</button>
          </div>
        </div>
      </div>
      <div class="msg-toast" v-show="isCommit">留言已提交成功，请耐心等待答复…</div>
    </div>
  </div>
</template>

<script>
import http from '../../api/http.js'
import apiUrl from '../../api/apiUrl.js'
import util from '../../api/util.js'
import 'jquery'

export default {
  name: '',
  data () {
    return {
      isActive: false,
      isShow: false,
      isCommit: false,
      isSimple: false
    }
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  created () {},

  methods: {
    enter() {
      this.isActive = true;
    },
    leave() {
      this.isActive = false;
    },
    leaveMsg() {
      this.isShow = true;
    },
    cancel() {
      this.isShow = false;
    },
    commitMsg() {
      const that = this;
      const name = $('#name').val();
      const connectLink = $('#connectLink').val();
      const msg = $('#msg').val();
      // 判断非空
      if (name && connectLink && msg) {
        const flag = util.checkConnectLink(connectLink);
        if (flag) {
          http.post(apiUrl.leaveMsg +'?name=' + name + '&contactInfo=' + connectLink + '&content=' + msg)
            .then(response => {
              if (response.code == 0) {
                that.isCommit = true;
                setTimeout(() => {
                  that.isCommit = false;
                  that.isShow = false;
                }, 1500);
              }
            })  
        } else {
          alert('联系方式填写不符合手机或邮箱格式要求');
        }
      } else {
        alert('输入不能为空');
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.msg-box {
  position: fixed;
  bottom:25%;
  right: 0;
  z-index:99;
  .main-box {
    width: 80px;
    height: 80px;
    border-radius: 8px 0 0 0;
    background: #FF789E;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      vertical-align: top\0;
      margin-top:25px\0; 
      width: 34px;
      height: 32px;
    }
  }
  .main-box-active {
    width: 220px;
    height: 80px;
    border-radius: 8px 0 0 0;
    background: #FFF8FA;
    box-shadow: 0px 2px 4px 0px rgba(106,56,70, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    line-height: 40px;
    line-height: 80px\0;
    color: #FF789E;
    img {
      vertical-align: top\0;
      margin-top:25px\0; 
      width: 34px;
      height: 32px;
      margin-left:20px;
    }
  }
  .leave-msg-box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto\0;
    text-align: center\0;
    .msg-toast {
      font-size: 20px;
      line-height: 28px;
      color: #FF789E;
      width: 380px;
      height: 160px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 15px;
      margin: 435px 630px\0;
    }
    .msg-wrapper {
      margin: 35px 630px\0;
      width: 630px;
      height: 910px;
      background-image: url(../../assets/images/bg_message.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      padding-left: 40px;
      text-align:left;
      font-size: 20px;
      color: #fff;
      box-sizing: border-box;
      .title-wrapper {
        position: absolute;
        top: 120px;
        h3 { font-size: 36px; line-height: 50px; margin-bottom: 10px;}
        p {font-size: 18px; line-height: 25px;}
      }
      .content-wrapper {
        position: absolute;
        top: 245px;
        p {font-size: 20px; line-height: 28px; margin-bottom: 16px;}
        input {
          width: 550px; height: 60px; border-radius: 15px; border: none; margin-bottom: 36px; padding:0 20px; box-sizing: border-box;
          font-weight: normal; font-weight: 100;
        }
        input:hover {border:none; outline:none;}
        input:focus {border:none; outline:none;}
        textarea {
          width: 550px; padding-top:10px; border-radius: 15px; border: none; margin-bottom: 36px; padding:20px 20px;box-sizing: border-box;
          word-wrap:break-word; font-weight: 500;
          resize: none;
        }
        textarea:hover {border:none; outline:none;}
        textarea:focus {border:none; outline:none;}
        .textarea {height: 220px;}
        .commit-btn { 
          width: 100%; 
          height: 60px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          button { width: 180px; height: 100%; background: #FF789E; color: #fff; border: none; border-radius: 15px; font-size: 20px; font-weight: 900; margin:0 180px;}
        }
      }
      .del-img {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 50px;
        left: 628px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/msgBox/msgBox.vue